const NAV=[
  {k:"dashboard",l:"Dashboard",i:"dash"},{k:"interns",l:"Interns",i:"user"},
  {k:"employees",l:"Employees",i:"users"},{k:"attendance",l:"Attendance",i:"clock"},
  {k:"payroll",l:"Payroll",i:"wallet"},{k:"advances",l:"Advances",i:"dollar"},
  // {k:"performance",l:"Performance",i:"chart"},{k:"announcements",l:"Announcements",i:"bell"},
  {k:"calendar",l:"Calendar",i:"cal"},{k:"notifications",l:"Notifications",i:"bell"},
  {k:"notes",l:"Notes",i:"note"},
  {k:"analytics",l:"Analytics",i:"chart"},{k:"audit",l:"Audit Log",i:"log"},
  {k:"bulk",l:"Bulk Actions",i:"bulk"},{k:"offboard",l:"Offboarding",i:"door"},
  {k:"settings",l:"Settings",i:"gear"},
];

const kpiData = [];
const interns = [];
const hrEmployees = [];
const leaveReqs = [];
const payrollFlow = [];
const advances = [];
const auditLogs = [];
const announcements = [];
const monthlyData = [];
const deptData = [];
const PCOL = ["#4338ca","#2563eb","#2563eb","#d97706","#ef4444","#8b5cf6","#ec4899"];
const offboardList = [];

export { NAV, kpiData, interns, hrEmployees, leaveReqs, payrollFlow, advances, auditLogs, announcements, monthlyData, deptData, PCOL, offboardList };
